import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import useMediaQuery from '@mui/material/useMediaQuery';
import { mq } from 'src/themes';
import { ProfileButton } from 'src/components/atoms/ProfileButton';
import { Flex } from 'src/components/layout';
import { AuthSideBar } from './AuthSideBar';
import { DrawerSideBar } from './DrawerSideBar';
import { MainContentHeader } from './MainContentHeader';

const LayoutContainer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 21rem 1fr;
  background-color: ${props => props.theme.palette.background.default};

  ${mq.lg} {
    grid-template-columns: 1fr;
    padding: 0 2rem;
  }
  ${mq.md} {
    padding: 0;
  }
`;

const Main = styled.main`
  position: relative;
  min-height: 100vh;
  height: max-content;
  width: 100%;
  display: grid;
  grid-template-rows: min-content 1fr;
  padding: 0 0.75rem;
  padding-left: 2rem;

  ${mq.lg} {
    padding-left: 4rem;
  }
  ${mq.md} {
    padding: 0 2rem;
  }
  ${mq.sm} {
    padding: 0 1rem;
    width: 100vw;
  }
`;

const MobileOutletContainer = styled.div`
  height: calc(100% + 3rem);
`;

export const AuthLayout = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const { breakpoints } = useTheme();
  const matchesLowerResolutionThanFullHd = useMediaQuery(breakpoints.down(breakpoints.values.lg + 1));
  const matchesMobile = useMediaQuery(breakpoints.down(breakpoints.values.md + 1));

  if (matchesMobile) {
    return (
      <>
        <Flex justifyContent='space-between' alignItems='center' pb={2} minWidth='21rem'>
          <DrawerSideBar isOpen={isNavOpen} isMobileDrawer setIsOpen={setIsNavOpen}>
            <AuthSideBar setIsOpen={setIsNavOpen} />
          </DrawerSideBar>
          <ProfileButton />
        </Flex>
        <LayoutContainer>
          <Main>
            <MainContentHeader hideLayoutUser />
            <MobileOutletContainer>
              <Outlet />
            </MobileOutletContainer>
          </Main>
        </LayoutContainer>
      </>
    );
  }

  if (matchesLowerResolutionThanFullHd) {
    return (
      <LayoutContainer>
        <DrawerSideBar isOpen={isNavOpen} isMobileDrawer={false} setIsOpen={setIsNavOpen}>
          <AuthSideBar />
        </DrawerSideBar>
        <Main>
          <MainContentHeader />
          <Outlet />
        </Main>
      </LayoutContainer>
    );
  }

  return (
    <LayoutContainer>
      <AuthSideBar />
      <Main>
        <MainContentHeader />
        <Outlet />
      </Main>
    </LayoutContainer>
  );
};
